/** Shared label/value row for shop detail cards (label left, value right). */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { palette } from '../../theme.ts';

export interface DetailRowProps {
  label: string;
  value: string;
}

export function DetailRow({ label, value }: Readonly<DetailRowProps>): React.JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        py: 0.6,
        gap: { xs: 0.25, sm: 2 },
      }}
    >
      <Typography sx={{ color: palette.textSecondary }}>{label}</Typography>
      <Typography
        sx={{
          fontWeight: 600,
          color: palette.textPrimary,
          textAlign: { sm: 'right' },
          overflowWrap: 'anywhere',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default DetailRow;
